export const Page404 = () => {
	return (
		<>
			<main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
				<div className="text-center">
					<p className="text-base text-5xl  font-semibold text-gray-600">404</p>
					<h1 className="mt-4  font-bold tracking-tight text-gray-900 text-4xl">Seite nicht gefunden</h1>
					<p className="mt-6 text-base leading-7 text-gray-600">Leider konnten wir die von Ihnen gesuchte Seite nicht finden.</p>
					<div className="mt-10 flex items-center justify-center gap-x-6">
						<a
							href="/"
							className="rounded-md border-2 text-indigo-600  border-indigo-600 px-3.5 py-2.5 text-sm font-semibold border-2 hover:text-indigo-500  hover:border-indigo-600 "
						>
							<span aria-hidden="true">←</span>  Zurück zur Startseite
						</a>
					</div>
				</div>
			</main>
		</>
	)
}